import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidEmailFormat } from '@awo-care/email-validation';

/**
 * Reactive-Forms-Validator, der strenger prüft als Angulars `Validators.email`
 * (verlangt eine echte TLD, verbietet doppelte Punkte etc.).
 *
 * Setzt bewusst denselben Fehler-Key `{ email: true }` wie Angulars
 * `Validators.email`, damit bestehende Fehlermeldungen (z.B. anguland
 * `lib-form-error`) ohne neue Übersetzungen weiterverwendet werden. Dadurch
 * kann er `Validators.email` ersetzen (gleiche Meldung, nur strenger) oder
 * additiv danebenstehen.
 *
 * Leere Werte gelten als gültig (für „required" ist `Validators.required`
 * zuständig).
 */
export function emailFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }
    return isValidEmailFormat(value) ? null : { email: true };
  };
}
